import {
  ActionIcon,
  Button,
  createTheme,
  type CSSVariablesResolver,
  Input,
  Modal,
} from "@mantine/core";

export const facetTheme = createTheme({
  primaryColor: "facetSignal",
  primaryShade: 7,
  fontFamily: "Inter, ui-sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
  defaultRadius: 2,
  colors: {
    facetSignal: ["#fff6f0", "#fce7da", "#f6cbb1", "#edaa82", "#df8654", "#d36d35", "#c65a1e", "#9f4314", "#833711", "#6c2d0e"],
  },
  components: {
    Button: Button.extend({ defaultProps: { radius: 2 } }),
    ActionIcon: ActionIcon.extend({ defaultProps: { radius: 2 } }),
    Input: Input.extend({ defaultProps: { radius: 2 } }),
    Modal: Modal.extend({
      defaultProps: {
        centered: true,
        overlayProps: { backgroundOpacity: 0.52, blur: 2 },
      },
    }),
  },
});

export const facetCssVariablesResolver: CSSVariablesResolver = () => ({
  variables: {
    "--mantine-color-body": "var(--canvas)",
    "--mantine-color-text": "var(--ink)",
    "--mantine-font-family": "Inter, ui-sans-serif, system-ui, sans-serif",
    "--mantine-radius-default": "2px",
  },
  light: {
    "--mantine-color-body": "var(--canvas)",
    "--mantine-color-text": "var(--ink)",
  },
  dark: {},
});
